import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik, ErrorMessage } from 'formik';
import Loading from "../components/loading";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { notifySuccess } from "../components/CitoPlusToastr";
import axiosInstance from "../../../../services/AxiosInstance";
import CustomSelect from "../components/Select";


const formActivoZonaSocialSchema = Yup.object().shape({
  nombre: Yup.string()
    .required("Por favor, ingresa un nombre.")
    .nullable(true),
  observaciones: Yup.string()
    .nullable(true),
  cantidad: Yup.number()
    .required("Por favor, ingresa una cantidad.")
    .min(1, 'La cantidad debe ser al menos 1')
    .nullable(true),
});

const FormAgregarActivoZonaSocial = ({ showModal, onClose, updateList, selectedZonaSocialUUID, selectedActivoUUID, editMode }) => {

  const initialValuesEmpty = {
    nombre: null,
    observaciones: null,
    cantidad: 1,
    activo: true,
    estado: "nuevo",
    zona_uuid: "",
  }
  const URL = "/api/v3/zonas-sociales/activos/";

  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initialValuesEmpty);

  // Options Zonas Sociales
  const URL_ZONAS = "/api/v3/zonas-sociales/zonas/dropdown/";
  const [zonaSocialDropDown, setZonaSocialDropDown] = useState([]);

  useEffect(() => {
    const fetchDataZonasSociales = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(URL_ZONAS);
        const data = await response.data;
        setZonaSocialDropDown(data);
      } catch (error) {
        if (error.response) {
          const errorMessages = Object.values(error.response.data).flat();
          const errorMessage = errorMessages.join("\n");
          Swal.fire('Error', errorMessage, "error");
        } else {
          Swal.fire('Error', error.message, "error");
        }
      } finally {
        setLoading(false);
      }
    };

    if (selectedZonaSocialUUID === null) {
      fetchDataZonasSociales();
    }
  }, []);
  // FIN Options Zonas Sociales

  // Modo de Edicion
  useEffect(() => {
    const fetchActivoDetalle = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(`${URL}${selectedActivoUUID}/`);
        const data = await response.data;
        setInitialValues({
          nombre: data.nombre,
          observaciones: data.observaciones,
          cantidad: data.cantidad,
          activo: data.activo,
          estado: data.estado || "nuevo",
        });
      } catch (error) {
        if (error.response) {
          const errorMessages = Object.values(error.response.data).flat();
          const errorMessage = errorMessages.join("\n");
          Swal.fire('Error', errorMessage, "error");
        } else {
          Swal.fire('Error', error.message, "error");
        }
      } finally {
        setLoading(false);
      }
    }

    if (editMode) {
      fetchActivoDetalle();
    } else {
      setInitialValues(initialValuesEmpty);
    }
  }, [editMode, selectedActivoUUID])
  // FIN Modo de Edicion

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const postData = {
      nombre: values.nombre,
      observaciones: values.observaciones || "",
      cantidad: values.cantidad,
      activo: values.activo,
      estado: values.estado || "nuevo",
      zona_uuid: selectedZonaSocialUUID ? selectedZonaSocialUUID : values.zona_uuid
    }
    try {
      let response = null;
      if (editMode) {
        const finalUrl = `${URL}${selectedActivoUUID}/`;
        response = axiosInstance.patch(finalUrl, postData);
      } else {
        response = axiosInstance.post(URL, postData);
      }
      const data = await response.data;
      resetForm(initialValuesEmpty);
      setInitialValues(initialValuesEmpty);
      onClose();
      updateList();
    } catch (error) {
      if (error.response) {
        const errorMessages = Object.values(error.response.data).flat();
        const errorMessage = errorMessages.join("\n");
        Swal.fire('Error', errorMessage, "error");
      } else {
        Swal.fire('Error', error.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Modal show={showModal} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{editMode ? "Editar Activo" : "Agregar Activo"}</Modal.Title>
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={formActivoZonaSocialSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <Modal.Body>

                {(selectedZonaSocialUUID === null && selectedActivoUUID === null) && (
                  <div className="form-group mb-3 row">
                    <div className='col-lg-4 col-form-label' htmlFor="zona_uuid">
                      <label className="form-label" htmlFor="zona_uuid">Zona Social </label>
                      <span className="text-danger">*</span>
                    </div>
                    <div className="col-lg-7">
                      <CustomSelect
                        id="zona_uuid"
                        name="zona_uuid"
                        options={zonaSocialDropDown}
                        onChange={(selectedOptions) => {
                          setFieldValue('zona_uuid', selectedOptions ? selectedOptions.value : null);
                        }}
                        defaultsValues={values.zona_uuid}
                      />
                    </div>
                    {errors.zona_uuid && touched.zona_uuid ? (
                      <div
                        id="val-zona-error"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      >
                        {errors.zona_uuid}
                      </div>
                    ) : null}

                  </div>
                )}

                <div className="form-group mb-3 row">
                  <div className="col-lg-4 col-form-label" htmlFor="activo">
                    Activo
                  </div>
                  <div className="col-lg-7">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="activo"
                      name="activo"
                      checked={values.activo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div
                      id="val-activo-error"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    >
                      {errors.activo}
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 row">
                  <div className='col-lg-4 col-form-label' htmlFor="nombre">
                    Nombre
                    <span className="text-danger">*</span>
                  </div>
                  <div className="col-lg-7">
                    <input
                      type="text"
                      className="form-control"
                      id="nombre"
                      name="nombre"
                      value={values.nombre || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div
                      id="val-nombre-error"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    >
                      {errors.nombre}
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 row">
                  <div className='col-lg-4 col-form-label' htmlFor="cantidad">
                    Cantidad
                    <span className="text-danger">*</span>
                  </div>
                  <div className="col-lg-7">
                    <input
                      type="number"
                      className="form-control"
                      id="cantidad"
                      name="cantidad"
                      value={values.cantidad || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      min="1"
                    />
                    <div
                      id="val-cantidad-error"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    >
                      {errors.cantidad}
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 row">
                  <div className='col-lg-4 col-form-label' htmlFor="estado">
                    Estado
                  </div>
                  <div className="col-lg-7">
                    <select
                      className="form-control"
                      id="estado"
                      name="estado"
                      value={values.estado || "nuevo"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="nuevo">Nuevo</option>
                      <option value="bueno">Bueno</option>
                      <option value="mantenimiento">En mantenimiento</option>
                      <option value="dado_de_baja">Dado de baja</option>
                    </select>
                    <div
                      id="val-estado-error"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    >
                      {errors.estado}
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 row">
                  <div className='col-lg-4 col-form-label' htmlFor="observaciones">
                    Observaciones
                  </div>
                  <div className="col-lg-7">
                    <input
                      type="text"
                      className="form-control"
                      id="observaciones"
                      name="observaciones"
                      value={values.observaciones || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div
                      id="val-observaciones-error"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    >
                      {errors.observaciones}
                    </div>
                  </div>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-sm btn-citoplus-danger"
                  onClick={onClose}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-citoplus-primary"
                  disabled={isSubmitting}
                >
                  {editMode ? "Actualizar" : "Agregar"}
                </button>
              </Modal.Footer>
            </form>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default FormAgregarActivoZonaSocial
